<template>
  <div>
    <el-dialog title="下单" :visible.sync="dialogVisible" width="680px" :destroy-on-close="true" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
      <el-form :rules="rules" ref="ruleForm" :model="formData" label-width="120px">
        <el-form-item label="承运商" prop="partnershipId">
          <el-select v-model="formData.partnershipId" placeholder="请选择承运商">
            <el-option v-for="item in partnershipList" :key="item.partnershipId" :label="item.partnerName" :value="item.partnershipId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市">
          <span>{{ formData.province }}{{ formData.city }}{{ formData.county }}</span>
        </el-form-item>
        <!-- <el-form-item label="京东仓库">
					<span>{{ formData.stationId }}{{ formData.stationName }}</span>
				</el-form-item>
				<el-form-item label="仓库地址">
					<span>{{ completeAddress }}</span>
				</el-form-item> -->
        <el-form-item label="回收数量">
          <span>{{ formData.waitCount || 0 }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmBtnFun" :loading="submitStatusFlag">提 交</el-button>
        <el-button @click="cancelBtnFun">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      formData: {
        partnershipId: undefined,
        address: undefined,
        alreadyCount: undefined,
        city: undefined,
        cityId: undefined,
        contactMobile: undefined,
        contactName: undefined,
        county: undefined,
        countyId: undefined,
        id: undefined,
        province: undefined,
        provinceId: undefined,
        recyclingCount: undefined,
        stat: undefined,
        stationId: undefined,
        stationName: undefined,
        town: undefined,
        townId: undefined,
        waitCount: undefined
      },
      rules: {
        region: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      partnershipList: [],
      submitStatusFlag: false
    }
  },
  computed: {
    completeAddress() {
      let { province = '', city = '', county = '', town = '', address = '', contactName = '', contactMobile = '' } = this.formData
      province = province != null ? province : ''
      city = city != null ? city : ''
      county = county != null ? county : ''
      town = town != null ? town : ''
      address = address != null ? address : ''
      contactName = contactName != null ? contactName : ''
      contactMobile = contactMobile != null ? contactMobile : ''
      return `${province}${city}${county}${town} ${address} ${contactName} ${contactMobile}`
    }
  },
  methods: {
    // 打开弹框
    opendDialog(rowData) {
      this.dialogVisible = true
      this.formData = Object.assign({}, this.formData, rowData)
      // console.log('====this.formData', this.formData)
      this.geetCarrierFun()
    },
    // 取消弹框
    cancelBtnFun() {
      this.resetFormData()
      this.dialogVisible = false
      // 重置下拉选项和承运商值
    },
    // 重置表单数据
    resetFormData() {
      Object.assign(this.formData, {
        partnershipId: undefined,
        address: undefined,
        alreadyCount: undefined,
        city: undefined,
        cityId: undefined,
        contactMobile: undefined,
        contactName: undefined,
        county: undefined,
        countyId: undefined,
        id: undefined,
        province: undefined,
        provinceId: undefined
      })
      this.partnershipList = []
      this.$refs.ruleForm.resetFields()
    },
    // 确认
    confirmBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.connfirmOrderFun()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 确认下单
    connfirmOrderFun() {
      this.parterChangeFun()
      this.submitStatusFlag = true
      // 网点回收地址
      // const url = `/autoapp-default-server-recovery/api/jd/recycle/saveRecycle`
      // const params = {
      // 	stationId: this.formData.stationId,
      // 	stationName: this.formData.stationName,
      // 	carrierNo: this.formData.partnershipId,
      // 	carrierName: this.formData.partnershipName
      // }
      // 城市回收地址
      const url = `/autoapp-default-server-recovery/api/jd/recycle/saveRecycleCity`
      const params = {
        id: this.formData.id,
        carrierNo: this.formData.partnershipId,
        carrierName: this.formData.partnershipName
      }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          this.$message.success('回收成功')
          this.$emit('opera-success')
          this.cancelBtnFun()
          // 重置下拉选项和承运商值
          this.resetFormData()
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
        this.submitStatusFlag = false
      })
    },
    // 选择改变承运商
    parterChangeFun() {
      const objItem = this.partnershipList.find(item => item.partnershipId == this.formData.partnershipId) || {}
      this.formData.partnershipName = objItem.partnerName
    },
    // 获取承运商列表
    getCarrierListFun() {
      const url = '/autoapp-default-server-recovery/api/jd/partnerManagementBond/pageJdPartnerShip'
      const params = {
        currPage: 1,
        pageSize: 999999
      }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          this.partnershipList = res.data || []
          // 在获取到承运商列表后，重新执行过滤操作
          this.filterPartnershipList()
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 获取承运商
    geetCarrierFun() {
      const provinceId = this.formData.provinceId
      const cityId = this.formData.cityId
      const countyId = this.formData.countyId

      let url = `/autoapp-default-server-recovery/api/jd/partnerManagementBond/findPartnerManagement?provinceId=${provinceId}&cityId=${cityId}`
      if (countyId) {
        url += `&countyId=${countyId}`
      }

      return this.HttpService.get(url)
        .then(res => {
          if (res.statusCode === 200) {
            // console.log('===res===', res)
            const listData = res.data || []
            if (listData.length > 0 && listData[0].carrierNo !== undefined) {
              this.getCarrierListFun()

              const carrierNo = parseInt(listData[0].carrierNo)
              this.formData.partnershipId = carrierNo
              // 调用独立的过滤方法
              this.filterPartnershipList()
            } else {
              this.$message.warning('该城市未分配承运商')
            }
          }
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    // 过滤承运商列表的独立方法
    filterPartnershipList() {
      if (this.formData.partnershipId) {
        this.partnershipList = this.partnershipList.filter(item => item.partnershipId == this.formData.partnershipId)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.dialog-footer {
  padding: 16px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/components/PlaceOrderDialog.vue